import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';

import {Observable} from 'rxjs';
import {AppStateService} from '../../shared/app-state.service';
import {pluck} from 'rxjs/operators';

@Component({
  selector: 'error-page',
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ErrorPageComponent implements OnInit {

  error$: Observable<string | null | undefined>;

  constructor(private route: ActivatedRoute,
              private AppState: AppStateService) {
  }

  ngOnInit() {
    this.AppState.loading$.next(false);
    this.error$ = this.route.params.pipe(pluck('code'));
  }
}
